import OverviewTab from "./gfgAdmin/OverviewTab";

export default function GfgAdmin() {
  return (
    <div className="flex flex-col h-full">
      <div className="flex-1">
        <OverviewTab />
      </div>
    </div>
  );
}
